import { useContext } from 'react';
import { getIcon, LinkSearchResultCard } from '@monash/portal-frontend-common';
import { SearchContextHoneycomb } from '@/components/providers/search-provider-honeycomb/SearchProviderHoneycomb';
import { getPrimaryUrl, resolveCategoryNames } from './utils';

const LinkSearchResultCardAdapter = ({
  entity,
  entityId,
  className,
  onLinkClick,
}) => {
  const { categories: allCategories } = useContext(SearchContextHoneycomb);

  const { linkType, name, description, icon, categories } = entity ?? {};

  return (
    <LinkSearchResultCard
      linkType={linkType ?? 'link'}
      name={name}
      description={description}
      icon={getIcon(icon)}
      categoryNames={resolveCategoryNames(categories, allCategories)}
      url={getPrimaryUrl(entity)}
      className={className}
      onClickCapture={() => {
        if (onLinkClick) {
          onLinkClick(entity, entityId);
        }
      }}
    />
  );
};

export default LinkSearchResultCardAdapter;
